<template>
	<div class="tw-flex-col tw--mx-3">
		<div class="px-3 tw-pb-3">
			<c-title-header
				:title="selectedJob.name"
				@go-to-back="goTo(codeStep.returnTo)"></c-title-header>
		</div>
		<div class="tw-flex">
			<div class="px-3 tw-w-3/5">
				<model-stepper
					:current-step="2"
					class="tw-mb-4"
					@code-step="loadCodeStep">
				</model-stepper>
				<p-card class="tw-flex-auto tw-flex tw-flex-col tw-justify-between tw-my-">
					<div class="tw-flex tw-justify-between tw-item-center tw-mb-1">
						<p class="tw-text-app-color-primary text-lg">
							Agregar Actividades del Puesto
						</p>
						<p-button
							type="primary"
							:disabled="tableData.length > 25"
							@click="addActivity">
							Agregar Actividades
						</p-button>
					</div>
					<div class="info tw-flex tw-item-center tw-gap-x-6 tw-mb-3">
						<img src="/static/img/enter.svg" alt="">
						<p>Presionar enter para agregar actividad</p>
					</div>
					<section class="verbs-list">
						<div class="text-uppercase verbs-list-header tw-px-10 tw-py-1 tw-flex tw-justify-items-start tw-mb-4 tw-gap-x-28">
							<span>ACTIVIDAD</span>
							<span>COMPLEMENTO</span>
						</div>
						<div class="list-verbs">
							<table>
								<tr v-for="(activity, index) in tableData" :key="index">
									<td class="verb tw-pr-1">
										<v-select
											class="select-core"
											hide-details
											:menu-props="{ contentClass: 'type-select-content' }"
											height="37"
											outline
											single-line
											autocomplete
											placeholder="Seleccionar Actividad"
											:items="listVerbs"
											item-value="id"
											item-text="name"
											v-model="selectActivities[index]"
											return-object
											@input="getVerbActivity($event, index)"
										></v-select>
									</td>
									<td class="complement tw-pl-1">
										<input
											placeholder="Complemento"
											v-model="complements[index]"
											class="list-verbs-input"
											@input="getComplement($event, index)"
											@keyup.enter="handleEnterKey">
									</td>
									<td>
										<app-tooltip-button
											img="/static/img/close2.svg"
											text="Eliminar"
											@click-icon="deleteActivity(index)"
										/>
									</td>
								</tr>
							</table>
						</div>
						<p-empty-message v-if="tableData.length < 1">
							Escoge de 5 a 25 verbos y<br>complementalos
						</p-empty-message>
						<div>
							<p-horizontal-divider />
							<div class="tw-text-center">
								<p-button
									type="primary"
									@click="goTo(codeStep.returnTo)"
								>
									Atrás
								</p-button>
								<p-button
									:disabled="validateEmptyFields || tableData.length < codeStep.minVerbs || tableData.length > 25"
									type="secondary"
									@click="saveStepTwo"
								>
									Siguiente
								</p-button>
							</div>
						</div>
					</section>
				</p-card>
			</div>
			<div class="px-3 tw-w-2/5">
				<model-description
					:title="'ACTIVIDADES DEL PUESTO'"
					:subtitle="'INSTRUCCIONES'">
					<div class="tw-my-4" slot="content">
						<p style="font-size: 13px;" class="tw-text-center">Escoge 3 verbos y responde a la pregunta ¿Para qué está este puesto?
							¿Cuál es el principal resultado, servicio o beneficio de este puesto?
						</p>
						<div class="content-box">
							<table>
								<tr>
									<th rowspan="11">Ejemplo:</th>
								</tr>
								<tr>
									<th class="titles">Verbo</th>
									<th class="titles">Complemento</th>
								</tr>
								<tr>
									<td class="borders"></td>
									<td class="borders"></td>
								</tr>
								<tr>
									<td class="verbs">Organizar</td>
									<td class="complements">a todo el equipo de contabilidad.</td>
								</tr>
								<tr>
									<th class="titles">Verbo</th>
									<th class="titles">Complemento</th>
								</tr>
								<tr>
									<td class="borders"></td>
									<td class="borders"></td>
								</tr>
								<tr>
									<td class="verbs">Dirigir</td>
									<td class="complements">toda las áreas de la empresa.</td>
								</tr>
								<tr>
									<th class="titles">Verbo</th>
									<th class="titles">Complemento</th>
								</tr>
								<tr>
									<td class="borders"></td>
									<td class="borders"></td>
								</tr>
								<tr>
									<td class="verbs">Diseñar</td>
									<td class="complements">plande estrategía para tu equipo.</td>
								</tr>
							</table>
						</div>
						<div class="tw-flex tw-flex-col tw-items-center">
							<br>
							<p-button
								class="tw-my-4"
								type="primary"
							>
								Mira nuestro tutorial paso a paso
							</p-button>
						</div>
					</div>
				</model-description>
			</div>
		</div>
	</div>
</template>

<script>
import cTitleHeader from '@/modules/job-profile/components/content/c-title-header';
import modelStepper from '@/modules/job-profile/components/content/model-stepper';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PEmptyMessage from '@/modules/shared/components/ui/p-empty-message';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import modelDescription from '@/modules/job-profile/components/content/model-description';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { path, pathOr } from 'ramda';

const { getLocalData } = helper;

async function loadData() {
	let typeVerb = this.selectedJob.typeVerb;
	if (typeVerb === 'UNDER') {
		typeVerb = 'low';
	} else if (typeVerb === 'MIDDLE') {
		typeVerb = 'medium';
	} else {
		typeVerb = 'high';
	}
	let keysVerb;
	if (Object.keys(this.selectedJob.highCommand).length > 0) {
		keysVerb = Object.keys(this.selectedJob.highCommand);
	} else if (Object.keys(this.selectedJob.mediumCommand).length > 0) {
		keysVerb = Object.keys(this.selectedJob.mediumCommand);
	} else if (Object.keys(this.selectedJob.lowCommand).length > 0) {
		keysVerb = Object.keys(this.selectedJob.lowCommand);
	}
	this.listVerbs = this.verbsSelection[`${typeVerb.toLowerCase()}Command`].details;
	try {
		if (this.codeStep) {
			// ✅ USAR CACHE - Llamar al servicio centralizado con cache
			const response = await this.$store.dispatch('jobProfile/loadJobDescription', {
				codeStep: this.codeStep.code,
				jobId: this.selectedJob.id,
			});
			if (Object.keys(response).length !== 0) {
				this.tableData = response.description;
				this.selectActivities = response.description.map(item => item.activity);
				this.complements = response.description.map(item => item.complement);
				this.validateEmptyFields = this.tableData.some(item => !item.activity || !item.complement);
			} else {
				this.selectActivities = this.listVerbs.filter(vrb => keysVerb.includes(vrb.code));
				this.tableData = this.selectActivities.map(dt => ({
					activity: dt,
					complement: '',
				}));
				this.validateEmptyFields = this.tableData.some(item => !item.activity || !item.complement);
			}
		}
	} catch (error) {
		this.showGenericError();
	}
}

function handleEnterKey() {
	this.tableData.push({
		activity: {},
		complement: '',
	});
	this.validateEmptyFields = this.tableData.some(item => !item.activity || !item.complement);
	if (this.tableData.length > 25) {
		this.showGenericError('Recuerda las actividades de deben superar los 25 en este paso', 'warning');
	}
}

function loadCodeStep(obj) {
	this.codeStep = obj;
}

function getVerbActivity(verb, index) {
	this.selectActivities[index] = verb;
	this.tableData[index].activity = this.selectActivities[index];
	this.validateEmptyFields = this.tableData.some(item => !item.activity || !item.complement);
}

function getComplement(comp, index) {
	this.complements[index] = comp.target.value;
	this.tableData[index].complement = this.complements[index];
	this.validateEmptyFields = this.tableData.some(item => !item.activity || !item.complement);
}

async function saveStepTwo() {
	this.tableData = this.tableData.map((f) => {
		const newF = { ...f };
		newF.activity = {
			id: f.activity.id,
			name: f.activity.name,
			code: f.activity.code,
		};
		return newF;
	});
	const body = {
		description: this.tableData,
		typeDescriptionCode: this.codeStep.code,
		jobId: this.selectedJob.id,
	};
	try {
		await this.$httpPraktiko.post('job-description', body);

		// ✅ INVALIDAR CACHE - Limpiar cache del job que se acaba de guardar
		this.$store.dispatch('jobProfile/clearJobDescriptionCache', this.selectedJob.id);

		this.showNotification('Actividades del Puesto Guardado Exitosamente');
		this.goTo(this.codeStep.goTo);
	} catch (error) {
		this.showGenericError();
	}
}

function deleteActivity(index) {
	this.tableData.splice(index, 1);
	this.complements.splice(index, 1);
	this.selectActivities.splice(index, 1);
	this.validateEmptyFields = this.tableData.some(item => !item.activity || !item.complement);
}

function addActivity() {
	this.tableData.push({
		activity: {},
		complement: '',
	});
	if (this.tableData.length > 25) {
		this.showNotification('Recuerda las actividades deben ser máximo 25 en este paso', 'warning');
	}
	this.validateEmptyFields = this.tableData.some(item => !item.activity || !item.complement);
}

function data() {
	return {
		tableData: [
		],
		codeStep: {},
		selectActivities: [],
		complements: [],
		listVerbs: [],
		validateEmptyFields: true,
	};
}

export default {
	name: 'job-activities',
	data,
	beforeMount() {
		// ✅ OPTIMIZADO: model-stepper ya carga la configuración
		// this.$store.dispatch('jobProfile/loadJobProfileConfig');
		this.$store.dispatch('jobEvaluation/loadVerbs');
	},
	created() {},
	mounted() {
		const typeVerb = this.selectedJob.typeVerb;
		this.listVerbs = this.verbsSelection[`${typeVerb.toLowerCase()}Command`].details;
	},
	components: {
		cTitleHeader,
		modelStepper,
		PCard,
		PEmptyMessage,
		PButton,
		PHorizontalDivider,
		modelDescription,
	},
	methods: {
		loadData,
		handleEnterKey,
		loadCodeStep,
		saveStepTwo,
		getVerbActivity,
		getComplement,
		deleteActivity,
		addActivity,
	},
	computed: {
		...mapState('jobProfile', {
			selectedJob(state) {
				return pathOr(getLocalData('selectedJob'), ['selectedJob'], state.jobProfile) || [];
			},
		}),
		...mapState('jobEvaluation', {
			verbsSelection: path(['supplies', 'guidelineModel', 'verbsSelection']),
		}),
	},
	watch: {
		codeStep: {
			handler(newVal) {
				this.loadData(newVal);
			},
		},
		verbsSelection: {
			handler(newVal) {
				const typeVerb = this.selectedJob.typeVerb;
				this.listVerbs = newVal[`${typeVerb.toLowerCase()}Command`].details;
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.info {
	border: 1px solid color(border-gray) !important;
	background-color: color(gray-light) !important;
	border-radius: 50px;
	color: color(gray-sidebar);
	font-size: size(medium);
	height: 30px !important;
	padding: 2px 10px;
	width: 50%;
}
.content-box {
	border: 1px solid color(border-gray);
	background-color: color(gray-light);
	border-radius: 5px;
	height: auto;
	width: 100%;
	padding: 10px;
	table {
		width: 100%;
		// border-collapse: collapse;
		text-align: center;
		font-size: 12px;
	}
	.borders {
		border-top: 1px solid color(green-dark);
		border-left: 1px solid color(green-dark);
		border-right: 1px solid color(green-dark);
		padding: 2px 0;
	}
	.titles {
		color: color(green-dark);
	}
	.verbs {
		color: color(orange-light);
	}
	.complements {
		color: color(gray-slider);
	}
}
.verbs-list {
	&-header {
		background-color: var(--app-color-primary);
		border-radius: 5px;
		span {
			color: white !important;
			font-weight: bold;
		}
	}
}
.list-verbs {
	display: flex;
	bottom: 0;
	left: 0;
	padding: 0;
	position: relative !important;
	right: 0;
	table {
		width: 100%;
		.verb {
			color: color(orange-light);
			font-size: size(large);
			padding-left: 10px;
			padding-top: 4px;
			width: 25%;
		}
		.complement {
			width: 70%;
		}
	}

	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 4px;
        display: block;
        outline: none;
		color: color(gray-tabs) !important;
		margin-top: 4px;
		padding: 10px 20px;
		width: 100%;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/job-profile/pages/second-page/job-activities.vue